import { Link } from 'react-router-dom'

import { EmptyState } from '@/components/ui'

export function NotFoundPage() {
  return (
    <EmptyState
      icon="alert"
      title="Такой страницы нет"
      description="Возможно, ссылка устарела."
      action={
        <Link to="/" className="inline-flex min-h-11 items-center font-medium text-accent lg:min-h-9">
          На главную
        </Link>
      }
    />
  )
}
